import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui-custom/Dialog";
import Button from "../ui-custom/Button";
import { Input, Textarea, Label } from "../ui-custom/Input";
import { Wallet } from "lucide-react";

export function AddPettyCashDialog({
  open,
  onOpenChange,
  onSubmit,
  title = "Add Petty Cash",
  description = "Add new funds to the petty cash pool. This will be available for allocation to team members.",
  submitLabel = "Add Funds",
  showRemarks = true,
  remarksLabel = "Notes (optional)",
  remarksPlaceholder = "Any additional notes...",
}) {
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");

  const handleSubmit = () => {
    if (!amount) return;

    onSubmit({
      amount: parseFloat(amount),
      notes: notes || undefined,
    });

    setAmount("");
    setNotes("");
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3">
            <div className="p-2 bg-sm-primary/10 rounded-lg">
              <Wallet className="w-5 h-5 text-sm-primary" />
            </div>
            <div>
              <DialogTitle className="text-lg font-semibold">{title}</DialogTitle>
              <p className="text-sm text-text-gray">
                {description}
              </p>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 p-6 py-4">
          <div className="space-y-2">
            <Label className="text-sm font-medium">Amount (₹)</Label>
            <Input
              type="number"
              placeholder="Enter amount"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
            />
          </div>

          {showRemarks && (
            <div className="space-y-2">
              <Label className="text-sm font-medium">{remarksLabel}</Label>
              <Textarea
                placeholder={remarksPlaceholder}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                rows={3}
                className="resize-none"
              />
            </div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Cancel
          </Button>
          <Button
            onClick={handleSubmit}
            disabled={!amount}
            variant="accent"
          >
            {submitLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
